import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const fetchUsers = async (data, token) => {
  return await axios.post(`${API_BASE_URL}/users`, data, {
    headers: {
        Authorization: `Bearer ${token}`,
    }
  });
};

export const addUser = async (userData, token) => {
  return await axios.post(`${API_BASE_URL}/users/add`, userData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editUser = async (_id, userData, token) => {
  return await axios.put(`${API_BASE_URL}/users/edit/${_id}`, userData, {
    headers: {
      Authorization: `Bearer ${token?.token}`,
    },
  });
};

export const getProfile = async (token) => {
  return await axios.get(`${API_BASE_URL}/users/profile`, {
    headers: {
      Authorization: `Bearer ${token?.token}`,
    },
  });
};

export const editPassword = async (userData, token) => {
  return await axios.put(`${API_BASE_URL}/users/change-password`, userData, {
    headers: {
      Authorization: `Bearer ${token?.token}`,
    },
  });
};

export const forgotPassword = async (userData, token) => {
  return await axios.put(`${API_BASE_URL}/users/forgot-password`, userData, {});
};